export * from './eol-ie'
import { default as EolIe } from './eol-ie'

export default EolIe
